import { render, staticRenderFns } from "./SlideSelectorComponent.vue?vue&type=template&id=08fd90b2&scoped=true&"
import script from "./SlideSelectorComponent.vue?vue&type=script&lang=js&"
export * from "./SlideSelectorComponent.vue?vue&type=script&lang=js&"
import style0 from "./SlideSelectorComponent.vue?vue&type=style&index=0&id=08fd90b2&prod&lang=scss&scoped=true&"
import style1 from "./SlideSelectorComponent.vue?vue&type=style&index=1&id=08fd90b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fd90b2",
  null
  
)

export default component.exports